<div class="form-page">
  <div class="form-page-chess" aria-hidden="true"></div>
  <div class="form-page-image" aria-hidden="true"></div>

  <div class="form-page-frame">
    <div class="form-page-row">
      <div class="form-page-visual">
        <div class="form-page-visual-stack">
          <button type="button" class="form-page-back-btn" (click)="RedirectToLogin()">
            <i class="fas fa-arrow-left" aria-hidden="true"></i>
            <span>Back</span>
          </button>

          <div class="form-page-visual-copy-block">
            <div class="form-page-visual-copy">
              <h2>Let's Get you Back to Smarter Operations.</h2>
              <p>Securely reset your password and continue managing your business with A-Square ERP.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="form-page-panel">
        <div class="forgot-form-center">
        <div class="forgot-form figma-auth-form" [class.is-variant2]="activeStep === 1">
          <div class="forgot-icon" aria-hidden="true">
            @if (activeStep === 1) {
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2.67" y="5.33" width="26.66" height="21.34" rx="4" stroke="#0076FE" stroke-width="2"/>
                <path d="M5.33 10.67L16 17.33L26.67 10.67" stroke="#0076FE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            } @else {
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 13.333V10.667a6 6 0 1 0-12 0v2.666" stroke="#0076FE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="6.667" y="13.333" width="18.667" height="13.333" rx="2.667" stroke="#0076FE" stroke-width="2"/>
                <circle cx="16" cy="20" r="1.333" fill="#0076FE"/>
                <path d="M16 21.333V24" stroke="#0076FE" stroke-width="2" stroke-linecap="round"/>
              </svg>
            }
          </div>

          <div class="forgot-form-intro">
            <div class="forgot-steps" role="progressbar" [attr.aria-valuenow]="activeStep < 3 ? activeStep + 1 : 3" aria-valuemin="1" aria-valuemax="3" aria-label="Password reset progress">
              @for (step of [0, 1, 2]; track step) {
                <span
                  class="forgot-step"
                  [class.is-active]="activeStep < 3 && activeStep === step"
                  [class.is-complete]="activeStep > step || activeStep === 3"
                ></span>
              }
            </div>

            <div class="forgot-heading">
              @if (activeStep === 0) {
                <h3>Forgot Password?</h3>
                <p>Enter your registered email or mobile number. We'll send you a verification code to reset your password.</p>
              }
              @if (activeStep === 1) {
                <h3>Verify Your Account</h3>
                <p>Enter the 6-digit code sent to your registered email or mobile number.</p>
              }
              @if (activeStep === 2) {
                <h3>Reset Password</h3>
                <p>Create a new password for your account.</p>
              }
              @if (activeStep === 3) {
                <h3>Password Updated</h3>
                <p>Your password is reset successfully. Please login to your account.</p>
              }
            </div>
          </div>

          <div class="forgot-form-main">
            @if (activeStep === 0) {
              <form class="forgot-form-body" [formGroup]="firstFormGroup" (ngSubmit)="ResetPassword()">
                <div class="field-item">
                  <label for="sfw-email">Email or Mobile Number*</label>
                  <div class="figma-input">
                    <input
                      type="text"
                      class="figma-input-field"
                      id="sfw-email"
                      placeholder="Enter registered email or mobile number"
                      formControlName="EmailID"
                      autocomplete="username"
                      data-initial-focus
                      (input)="clearContactError()"
                    />
                  </div>
                  @if (firstFormGroup.get('EmailID')?.invalid && firstFormGroup.get('EmailID')?.touched) {
                    <small class="field-error">Please enter email or mobile number.</small>
                  }
                  @if (IsContactFormatInvalid) {
                    <small class="field-error">Enter a valid email or 10-digit mobile number.</small>
                  }
                  @if (IsContactValid) {
                    <small class="field-error">Invalid email or mobile number. Please try again.</small>
                  }
                </div>

                <button class="forgot-submit-btn" type="submit">
                  <span class="forgot-submit-btn-label">Send Verification Code</span>
                </button>
              </form>
            }

            @if (activeStep === 1) {
              <form class="forgot-form-body" [formGroup]="secondFormGroup" (ngSubmit)="ValidateOTP()">
                <div class="forgot-otp-row" role="group" aria-label="One-time password">
                  @for (digit of otpDigits; track $index; let i = $index) {
                    @if (i === 3) {
                      <span class="forgot-otp-dash" aria-hidden="true"></span>
                    }
                    <input
                      type="text"
                      class="forgot-otp-box"
                      inputmode="numeric"
                      maxlength="1"
                      autocomplete="one-time-code"
                      [attr.aria-label]="'Digit ' + (i + 1)"
                      [attr.data-initial-focus]="i === 0 ? true : null"
                      [value]="digit"
                      (input)="onOtpInput($event, i)"
                      (keydown)="onOtpKeydown($event, i)"
                      (paste)="onOtpPaste($event)"
                    />
                  }
                </div>
                @if (secondFormGroup.get('OTP')?.invalid && secondFormGroup.get('OTP')?.touched) {
                  <small class="field-error">Please enter OTP.</small>
                }
                @if (IsOTPValid) {
                  <small class="field-error">Invalid OTP. Please try again.</small>
                }

                <p class="forgot-resend">
                  Didn't receive the code?
                  <a (click)="ResendOTP()">Resend OTP</a>
                </p>

                <button class="forgot-submit-btn" type="submit">
                  <span class="forgot-submit-btn-label">Verify Code</span>
                </button>
              </form>
            }

            @if (activeStep === 2) {
              <form class="forgot-form-body" [formGroup]="thirdFormGroup" (ngSubmit)="ResetSavePassword()">
                <div class="field-item">
                  <label for="sfw-pw">Password*</label>
                  <div class="figma-input">
                    <input
                      [type]="hide ? 'password' : 'text'"
                      class="figma-input-field"
                      id="sfw-pw"
                      placeholder="Enter Password"
                      formControlName="Password"
                      autocomplete="new-password"
                      data-initial-focus
                    />
                    <button type="button" class="figma-input-toggle" (click)="hide = !hide" [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
                      <i class="fas" [class.fa-eye]="hide" [class.fa-eye-slash]="!hide" aria-hidden="true"></i>
                    </button>
                  </div>
                  @if (thirdFormGroup.get('Password')?.invalid && thirdFormGroup.get('Password')?.touched) {
                    <small class="field-error">Please enter password.</small>
                  }
                </div>

                <div class="field-item">
                  <label for="sfw-pw2">Confirm Password*</label>
                  <div class="figma-input">
                    <input
                      [type]="confirmhide ? 'password' : 'text'"
                      class="figma-input-field"
                      id="sfw-pw2"
                      placeholder="Confirm Password"
                      formControlName="ConfirmPassword"
                      autocomplete="new-password"
                    />
                    <button type="button" class="figma-input-toggle" (click)="confirmhide = !confirmhide" [attr.aria-label]="confirmhide ? 'Show password' : 'Hide password'">
                      <i class="fas" [class.fa-eye]="confirmhide" [class.fa-eye-slash]="!confirmhide" aria-hidden="true"></i>
                    </button>
                  </div>
                  @if (thirdFormGroup.get('ConfirmPassword')?.invalid && thirdFormGroup.get('ConfirmPassword')?.touched) {
                    <small class="field-error">Please enter password.</small>
                  }
                  @if (IsPasswordNotMatch) {
                    <small class="field-error">Password not matched. Please try again.</small>
                  }
                </div>

                <button class="forgot-submit-btn" type="submit">
                  <span class="forgot-submit-btn-label">Reset Password</span>
                </button>
              </form>
            }

            @if (activeStep === 3) {
              <div class="forgot-form-body">
                <button type="button" class="forgot-submit-btn" (click)="RedirectToLogin()">
                  <span class="forgot-submit-btn-label">Login</span>
                </button>
              </div>
            }

            @if (activeStep === 1) {
              <p class="forgot-login-footer">
                Wrong email or number?
                <a (click)="GoBackToEmail()">Go back</a>
              </p>
            } @else if (activeStep !== 3) {
              <p class="forgot-login-footer">
                Remember your password?
                <a (click)="RedirectToLogin()">Login</a>
              </p>
            }
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
